import React from 'react'
import {createIcon} from '@chakra-ui/react'

export const DownloadIcon = createIcon({
  displayName: 'DownloadIcon',
  viewBox: '0 0 24 24',
  path: (
    <path
      d="M19 9.5H15V3.5H9V9.5H5L12 16.5L19 9.5ZM11 11.5V5.5H13V11.5H14.17L12 13.67L9.83 11.5H11ZM5 18.5H19V20.5H5V18.5Z"
      fill="black"
    />
  ),
})
